'use client';

import { createContext, use } from 'react';

/** 与 Flutter `MacaronCardScope`：首层 Column 在 Card 内用 12px 间距，子树重置为 false */
export const MacaronCardActiveContext = createContext(false);

/** 与 Flutter `MacaronButtonScope`：Row 在 Button 内用 4px 间距；Button 默认撑满可用宽度，同行布局再按需收窄 */
export const MacaronButtonInnerContext = createContext(false);
export const MacaronButtonFillContext = createContext(true);
export const MacaronFullScreenModalOpenContext = createContext<(() => void) | null>(null);
export const MacaronSelectionItemScopeContext = createContext(false);
export const MacaronSelectionItemActiveContext = createContext(false);
export const MacaronNumericQuantityLabelContext = createContext(false);

export function useMacaronCardActive() {
  return use(MacaronCardActiveContext);
}

export function useMacaronButtonInner() {
  return use(MacaronButtonInnerContext);
}

export function useMacaronButtonFill() {
  return use(MacaronButtonFillContext);
}

export function useMacaronSelectionItemActive() {
  return use(MacaronSelectionItemActiveContext);
}

export function useMacaronSelectionItemScope() {
  return use(MacaronSelectionItemScopeContext);
}

export function useMacaronNumericQuantityLabel() {
  return use(MacaronNumericQuantityLabelContext);
}
